<main class="page-main">
	<app-page-sub-nav [data]="pageSubNavData" [currVisible]="currVisible"></app-page-sub-nav>
	<section class="page-section" id="overview">
		<h2 id="sectionTitleOverview" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('overview')">
			Overview <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<app-external-resource [componentName]="'Progress Indicator'" [includeDescription]="true"
			[otherNames]="true"></app-external-resource>
	</section>
	<section class="page-section" id="example">
		<h2 id="sectionTitleExample" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('example')">
			Live example <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<div class="example-container k-body">
			<div class="page-live-header">
				<select class="page-live-example-select" (change)="changeCurrLive($event)" title="Change example">
					<option value="determinate">Determinate line</option>
					<option value="reverse-determinate">Reverse determinate line</option>
					<option value="indeterminate">Indeterminate line</option>
					<option value="circle">Circle</option>
					<option value="button">Progress indicators with buttons</option>
				</select>
				<app-theme-switcher></app-theme-switcher>
			</div>
			<div class="page-live-example-content">
				<div class="page-live-example line" [class.page-live-show]="currLive === 'determinate'">
					<div class="example-config">
						<button themeColor="primary" [disabled]="!!running || determinateValue === 100"
							(click)="startProgress()">
							{{ determinateValue > 1 ? 'Resume' : 'Start' }} live example
						</button>
						<button [disabled]="!running" (click)="stopProgress()">
							Stop live example
						</button>
						<button [disabled]="determinateValue <= 1" (click)="resetProgress()">
							Reset live example
						</button>
					</div>
					<kendo-progressbar [value]="determinateValue"></kendo-progressbar>
					<div class="percentage progress_label">
						{{ determinateValue }}%
					</div>
				</div>
				<div class="page-live-example line" [class.page-live-show]="currLive === 'reverse-determinate'">
					<div class="example-config">
						<button themeColor="primary" [disabled]="!!running || reverseDeterminateValue === 0"
							(click)="startProgress()">
							{{ reverseDeterminateValue < 100 ? 'Resume' : 'Start' }} live example </button>
								<button [disabled]="!running" (click)="stopProgress()">
									Stop live example
								</button>
								<button [disabled]="reverseDeterminateValue > 99" (click)="resetProgress()">
									Reset live example
								</button>
					</div>
					<kendo-progressbar [value]="reverseDeterminateValue"></kendo-progressbar>
					<div class="percentage progress_label">
						{{ reverseDeterminateValue }}%
					</div>
				</div>
				<div class="page-live-example" [class.page-live-show]="currLive === 'indeterminate'">
					<kendo-progressbar [indeterminate]="true"></kendo-progressbar>
				</div>
				<div class="page-live-example" [class.page-live-show]="currLive === 'circle'">
					<kendo-circularprogressbar style="width: 44px; height: 44px" [indeterminate]="true"
						[value]="50"></kendo-circularprogressbar>
					<kendo-circularprogressbar style="width: 68px; height: 68px" [indeterminate]="true"
						[value]="50"></kendo-circularprogressbar>
				</div>
				<div class="page-live-example" [class.page-live-show]="currLive === 'button'">
					<div class="button-progress-container">
						<section class="progress_section">
							<button kendoButton fillMode="none" class="sh-button-with-progress">
								<kendo-progressbar [indeterminate]="true" [value]="20"></kendo-progressbar>
								<div class="progress-button-text">Test Configuration</div>
							</button>
							<div class="progress_label">
								<span class="progress-button-label">Testing...</span>
							</div>
						</section>
					</div>
				</div>
			</div>
		</div>
	</section>
	<section class="page-section" id="dev">
		<h2 id="sectionTitleDev" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('dev')">
			Developer resources
			 <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<section class="page-sub-section" id="dev-started">
			<h3 id="subSectionTitleDevStarted" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('dev-started')">
				Getting started <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			Added to your project's app.module.ts file:
			<code style="margin: 10px 0">import &#123; ProgressBarModule &#125; from
				'&#64;progress/kendo-angular-progressbar';
			</code>
			* The progress indicators with buttons is just an example of how to implement a kendo progress bar within a
			kendo button and how it should be displayed.
		</section>
		<section class="page-sub-section" id="dev-code">
			<h3 id="subSectionTitleDevCode" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('dev-code')">
				Code examples <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<pre prism class="dark">
				{{progressIndicatorHTML}}
			</pre>
		</section>
		<section class="page-sub-section" id="dev-api">
			<h3 id="subSectionTitleDevApi" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('dev-api')">
				API <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					<a class="page-kendo-link" target="_blank"
						href="https://www.telerik.com/kendo-angular-ui/components/progressbars/api/"><svg
							xmlns="http://www.w3.org/2000/svg" width="18px" height="18" viewBox="0 0 49 60.3">
							<path fill="#5ce500"
								d="M11.2 14.9L0 21.3l17.4 10.1v20.1l11.2-6.4c.5-.3.9-1 .9-1.6V24.4L13 14.9c-.5-.3-1.3-.3-1.8 0z">
							</path>
							<path fill="#5ce500"
								d="M12.1 48.4V34.5L0 41.5zM25 .2c-.5-.3-1.3-.3-1.8 0L10.7 7.4l24.1 13.9v27.9L47.3 42c.5-.3.9-1 .9-1.6V13.6L25 .2z">
							</path>
						</svg>Kendo ProgressBars API</a>
				</li>
				<li class="page-section-list-item">
					Refer to the
					<a href="components/progress-indicator#behaviors">behaviors section</a>
					to see supported component features.
				</li>
			</ul>
		</section>
	</section>
	<section class="page-section" id="styles">
		<h2 id="sectionTitleStyles" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('styles')">
			Styles <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<ul class="page-section-list">
			<li class="page-section-list-item">
				<details class="page-style-details">
					<summary class="page-style-summary">
						Color (light theme)
					</summary>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Color / Token</span>
						</li>
						<app-style-row *ngFor="let item of stylesDefault" [data]="item"></app-style-row>
					</ul>
				</details>
			</li>
			<li class="page-section-list-item">
				<details class="page-style-details">
					<summary class="page-style-summary">
						Color (dark theme)
					</summary>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Color / Token</span>
						</li>
						<app-style-row *ngFor="let item of stylesDark" [data]="item"></app-style-row>
					</ul>
				</details>
			</li>
			<li class="page-section-list-item">
				<details class="page-style-details">
					<summary class="page-style-summary">Typography</summary>
					<span class="page-style-list-title">Circle</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Value</span>
						</li>
						<app-style-row *ngFor="let item of stylesCircleTypography" [data]="item"></app-style-row>
					</ul>
				</details>
			</li>
			<li class="page-section-list-item">
				<details class="page-style-details">
					<summary class="page-style-summary">Structure</summary>
					<span class="page-style-list-title">Line</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Value</span>
						</li>
						<app-style-row *ngFor="let item of stylesLineStructure" [data]="item"></app-style-row>
					</ul>
					<span class="page-style-list-title">Circle</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Value</span>
						</li>
						<app-style-row *ngFor="let item of stylesCircleStructure" [data]="item"></app-style-row>
					</ul>
				</details>
			</li>
		</ul>
	</section>
	<section class="page-section" id="behaviors">
		<h2 id="sectionTitleBehaviors" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('behaviors')">
			Behaviors <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<section class="page-sub-section" id="behaviors-animation">
			<h3 id="subSectionTitleBehaviorsAnimation" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('behaviors-animation')">
				Animation <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					<span class="page-section-list-item-sub-title">Indeterminate progress indicators</span>
					Repeating progress indicators, known as indeterminate progress indicators, are on an endless
					cycle through their animation. The indeterminate line takes 1 second to fully travel from start
					to finish. The indeterminate circle takes 1.4 seconds to complete a single rotation.
				</li>
				<li class="page-section-list-item">
					<span class="page-section-list-item-sub-title">Determinate progress indicators</span>
					Determinate, or non-repeating progress indicators, move at the same speed as the loading data.
					For example, if the data takes 20 seconds to load, then the determinate line takes 20 seconds
					from start to finish.
				</li>
			</ul>
		</section>
	</section>
	<section class="page-section" id="variations">
		<h2 id="sectionTitleVariations" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('variations')">
			Variations <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<section class="page-sub-section" id="variations-line">
			<h3 id="subSectionTitleVariationsLine" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('variations-line')">
				Determinate line <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					These progress indicators are provided a value between 0 and 100 to determine what percentage of the
					line is filled.
					Line indicators fill the width of their container.
				</li>
			</ul>
		</section>
		<section class="page-sub-section" id="variations-repeating-line">
			<h3 id="subSectionTitleVariationsRepeatingLine" class="page-sub-section-title"
				title="Copy Link to Clipboard" (click)="copyToClipboard('variations-repeating-line')">
				Indeterminate line <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					These progress indicators endlessly repeat. They can move in either direction. The animation
					restarts once the indicator is fully finished.
				</li>
			</ul>
		</section>
		<section class="page-sub-section" id="variations-circle">
			<h3 id="subSectionTitleVariationsCircle" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('variations-circle')">
				Indeterminate circle <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					Circular progress indicators endlessly repeat a spinning motion. It takes 1.4 seconds to complete a
					rotation.
				</li>
			</ul>
		</section>
		<section class="page-sub-section" id="variations-reverse-line">
			<h3 id="subSectionTitleVariationsReverseLine" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('variations-reverse-line')">
				Reverse determinate line <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					Reverse determinate line indicators have the same behavior as determinate line indicators, except
					the value
					decreases from 100% instead of increases. These indicators are helpful to show a “countdown” and are
					used in toasts.
				</li>
			</ul>
		</section>
	</section>
	<section class="page-section" id="usage">
		<h2 id="sectionTitleUsage" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('usage')">
			Usage guidelines <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<section class="page-sub-section" id="usage-general">
			<h3 id="subSectionTitleUsageGeneral" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('usage-general')">
				General <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					<span class="page-section-do-list-title">Determinate vs indeterminate</span>
					<ul class="page-section-do-list">
						<li class="page-section-list-item">
							Determinate indicators work best if there are specific steps in the process that the user
							can follow along with,
							or if the expected load time is more than a few seconds. Use determinate when the percentage
							completed can be displayed.
						</li>
						<li class="page-section-list-item">
							Indeterminate progress indicators should be used when the load time is unknown.
						</li>
					</ul>
				</li>
				<li class="page-section-list-item" style="margin-top: 5px">
					<span class="page-section-do-list-title">Line vs circle</span>
					<ul class="page-section-do-list">
						<li class="page-section-list-item">
							Use line indicators in grids, cards, and buttons.
						</li>
						<div class="redlines-container">
							<img src="/assets/images/redlines/progress_indicator/progress_indicator_grid.png" style="width:600px; height: 350px;">
						</div>
						<span class="redlines-caption">Example of repeating line indicator in grid.</span>
						<li class="page-section-list-item">
							Use circle indicators in the middle of the screen, next to buttons, and next to transitional
							text.
						</li>
					</ul>
				</li>
			</ul>
		</section>
		<section class="page-sub-section" id="usage-content">
			<h3 id="subSectionTitleUsageContent" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('usage-content')">
				Content <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					<span class="page-section-list-item-sub-title">Transitional text</span>
					You can use words to help support progress indicators. This text should communicate what action is
					underway and that users will have to wait.
				</li>
				<li class="page-section-list-item">
					Use specific verbs and ellipses, like:
				</li>
				<li class="page-section-list-item">
					<ul class="page-section-do-list">
						<li class="page-section-list-item">
							Saving...
						</li>
						<li class="page-section-list-item">
							Retrieving Info...
						</li>
						<li class="page-section-list-item">
							Deleting...
						</li>
					</ul>
				</li>
			</ul>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					<span class="page-section-list-item-sub-title">Labels</span>
					Progress indicators need accessibility labels to help users who can’t rely on visual cues. Use
					labels that clearly describe the purpose of the progress indicator and what content will be loaded.
					Keep labels concise—1-3 words on a single line of text.
				</li>
				<li class="page-section-list-item">
					Circular progress indicators can have labels. If a standard label cannot be used due to space, like
					on toasts
					and grids, then the indicator should use a hidden aria label. The label should indicate what content
					is loading
					and what the action is. For example, “Refreshing grid…”.
				</li>
			</ul>
		</section>
		<section class="page-sub-section" id="usage-with-buttons">
			<h3 id="subSectionTitleUsageWithButtons" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('usage-with-buttons')">
				Progress indicators with buttons <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					In its default state, a button with an integrated progress indicator is not discernible from a
					regular button.
				</li>
				<li class="page-section-list-item">
					Once a user has selected the button, a linear progress indicator appears directly above. This should
					not shift
					any elements on the page. Transitional text appears to let the user know what action is underway.
				</li>
				<li class="page-section-list-item">
					If the action fails or succeeds, an error or success message appears to the right of the button with
					a
					corresponding icon. The progress indicator is hidden at this point.
				</li>
				<li class="page-section-list-item">
					<div class="redlines-container" style="width:280px; height:210px; ">
						<img src="/assets/images/redlines/progress_indicator/progress_indicator_with_buttons.png" style="width:280px; height:210px;">
					</div>
					<span class="redlines-caption">Example of progress indicators with buttons.</span>
				</li>
			</ul>
		</section>
		<section class="page-sub-section" id="usage-placement">
			<h3 id="subSectionTitleUsagePlacement" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('usage-placement')">
				Placement <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					Determinate progress indicators are typically placed at the top of the button, card, or panel that
					has the loading process. They are in a fixed position at the top 4px of the container’s space.
					Content is not pushed down when it appears or disappears.
				</li>
			</ul>
		</section>
	</section>
	<section class="page-section" id="related">
		<h2 id="sectionTitleRelated" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('related')">
			Related <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>

		<span class="page-related-list-title">Referenced in this section:</span>
		<ul class="page-section-list page-related-list">
			<li class="page-related-list-item">
                <a href="guidelines/colors">Colors guidelines</a>
            </li>
			<li class="page-related-list-item">
				<a href="guidelines/motion">Motion guidelines</a>
			</li>
			<li class="page-related-list-item">
				<a href="guidelines/typography">Typography guidelines</a>
			</li>
		</ul>

		<span class="page-related-list-title">Components and patterns that use
			progress indicators:</span>
		<ul class="page-section-list page-related-list">
			<li class="page-related-list-item">
				<a href="components/data-grid">Data grid component</a>
			</li>
			<li class="page-related-list-item">
				<a href="components/button">Button component</a>
			</li>
			<li class="page-related-list-item">
				<a href="components/toast">Toast component</a>
			</li>

		</ul>
	</section>
	<section class="page-section" id="history">
		<h2 id="sectionTitleHistory" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('history')">
			Revision history <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<ul class="page-history-list">
			<li class="page-history-list-item" *ngFor="
						let subItem of changelogService.getChangelogBySection(
							'Progress Indicator Component'
						)
					">
				<span class="page-history-list-item-title">{{
					changelogService.formatDate(subItem.changeDate)
					}}</span>
				<a class="page-history-list-item-link" target="_blank" *ngIf="subItem.workId != ''" [attr.href]="
							'https://beyondtrust.atlassian.net/jira/software/c/projects/SDS/issues/' +
							subItem.workId
						">[{{ subItem.workId }}]</a>{{ subItem.changeName }}
			</li>
		</ul>
	</section>
</main>